import locales from "@/assets/locales/en.json"
import * as Config from "@/config"
import { API_BASE_PATH } from "@/const/default-values"
import { SLUG_LS } from "@/const/local-storage.constants"
import { RESOURCES_NAMES } from "@/const/resource.constants"
import { getLanguage } from "@/domain/user"
import { isSelfHosted } from "@/helpers/self-hosted.helper"
import { createDefaultAdapter, ServicesContext } from "@/hooks/useServices"
import { AuthAdapter } from "@/services/auth-adapter"
import * as download from "@/services/download"
import { HttpAdapter } from "@/services/http-adapter"
import { IntercomAdapter } from "@/services/intercom-adapter"
import Logger, { createTransportsByEnv } from "@/services/logger-adapter"
import i18n from "i18next"
import { useMemo } from "react"
import { initReactI18next } from "react-i18next"

const ServicesProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const services = useMemo(() => {
    const auth = createDefaultAdapter(AuthAdapter, {
      apiKey: Config.FIREBASE_API_KEY,
      authDomain: Config.FIREBASE_AUTH_DOMAIN,
      slug: localStorage.getItem(SLUG_LS) || ""
    })
    const logger = new Logger({
      transports: createTransportsByEnv(Config, isSelfHosted())
    })

    return {
      auth,
      logger,
      download,
      http: createDefaultAdapter(HttpAdapter, {
        auth,
        logger,
        apiUrl: API_BASE_PATH,
        exchangeTokenUrl: RESOURCES_NAMES.AUTHENTICATION.AUTH
      }),
      t: i18n.use(initReactI18next).init({
        resources: locales,
        lng: getLanguage(localStorage.getItem(SLUG_LS)),
        fallbackLng: "en",
        interpolation: {
          escapeValue: false
        }
      }),
      localStorage,
      intercom: createDefaultAdapter(IntercomAdapter, {
        logger,
        appId: Config.INTERCOM_APP_ID,
        isDev: Config.isDev,
        isSelfHosted: isSelfHosted()
      })
    }
  }, [])

  return (
    <ServicesContext.Provider value={services}>
      {children}
    </ServicesContext.Provider>
  )
}

export default ServicesProvider
